import { useEffect } from 'react'
import { fetchAndActivate, getValue, RemoteConfig } from 'firebase/remote-config'
import { parseRemoteValue, PartialRemoteConfigMap, setConfig } from './utils'
import { ensureConfigActivated, firebaseConfiguration } from './analytics'
import { useDispatch } from 'react-redux'

import { remoteConfigs } from '@/constants/utils'
import { setRemoteConfig } from '@/app/remoteConfigSlice'

const REMOTE_CONFIG_REFRESH_RATE = 60 * 1000

function updateFromRemoteConfig(dispatch: ReturnType<typeof useDispatch>, remoteConfig: RemoteConfig) {
  const updated: PartialRemoteConfigMap = {}
  remoteConfigs.forEach((config) => {
    const raw = getValue(remoteConfig, config.key)
    const parsed = parseRemoteValue(raw, config)
    const finalValue = config.validOrDefault(parsed)

    if (raw.getSource() === 'remote') {
      setConfig(updated, config.key, finalValue)
    }
  })

  dispatch(setRemoteConfig(updated))
}

export function useRemoteConfigListener() {
  const dispatch = useDispatch()

  useEffect(() => {
    const remoteConfig = firebaseConfiguration

    ensureConfigActivated()
      .then(() => {
        updateFromRemoteConfig(dispatch, remoteConfig)
      })

    // There's no 'onConfigUpdated' on web, so simulate periodic refresh
    const interval = setInterval(() => {
      console.debug('[Remote Config] Periodic fetch')
      fetchAndActivate(remoteConfig)
        .then(() => {
          updateFromRemoteConfig(dispatch, remoteConfig)
        })
        .catch((err) => {
          console.error('[Remote Config] Periodic fetch failed', err)
        })
    }, REMOTE_CONFIG_REFRESH_RATE)

    return () => {
      console.debug('[Remote Config] Clearing interval for remote config updates')
      clearInterval(interval)
    }
  }, [dispatch])
}
